/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Total_WeightInputs */

const vi_order_total_weight = /** @type {(inputs: Order_Total_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng trọng lượng`)
};

/**

* @param {Order_Total_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_total_weight = /** @type {((inputs?: Order_Total_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Total_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_total_weight(inputs)
});